export const COOKIE_NAME_AUTH = '_taptab';
export const COOKIE_RESTAURANT_ID = '_restaurantID';
export const COOKIE_STRIPE_SESSION_ID = '_stripe';
